import {
  IonButton,
  IonCard,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import {
  addCircle,
  checkbox,
  removeCircle,
  squareOutline,
  tabletLandscape,
  trashOutline,
} from "ionicons/icons";
import { useCart } from "./useCart";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import SubHeader from "../FrameAndEasel/SubHeader";
import { usePictures } from "../Pictures/usePictures";
import { useCommon } from "../../common/useCommon";

const FrameAssembled = () => {
  const {
    framesAssembled,
    cartPictures,
    changeFrameAssembledNumber,
    framesAssembledAsPictures,
    framesAssembledAsPicturesToggle,
  } = useCart();

  const { currency } = useCommon();
  const { equipmentPrice, equipmentState } = usePictures();
  const disabled = !equipmentState.frameAssembled;
  const disabledButton = currency === "KM";
  const allowAdd =
    !framesAssembledAsPictures && cartPictures.length && !disabledButton;
  const allowRemove =
    framesAssembled > 0 && !framesAssembledAsPictures && !disabledButton;

  return (
    <IonCard style={{ margin: "3px", padding: "13px 16px 0 16px" }}>
      <SubHeader
        icon={tabletLandscape}
        text="Drveni (blind) ram - sklopljen sa postavljenim platnom"
        onTop
        disabled={disabled}
      >
        <NumberMoney value={equipmentPrice.frameAssembled} />
      </SubHeader>

      {!disabled && (
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-right">
              {framesAssembled > 0 && (
                <IonIcon
                  className={allowRemove ? "cursorP" : "op5"}
                  icon={framesAssembled === 1 ? trashOutline : removeCircle}
                  size="large"
                  color={allowRemove ? "primary" : "var(--ion-color-light)"}
                  onClick={() => {
                    if (allowRemove) {
                      changeFrameAssembledNumber(framesAssembled - 1);
                    }
                  }}
                />
              )}
            </IonCol>
            <IonCol className="ion-text-center f20 b" style={{ paddingTop: 7 }}>
              <IonLabel>{framesAssembled}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                className={allowAdd ? "cursorP" : "op5"}
                color={allowAdd ? "primary" : "var(--ion-color-light)"}
                icon={addCircle}
                size="large"
                onClick={() => {
                  if (allowAdd) {
                    changeFrameAssembledNumber(framesAssembled + 1);
                  }
                }}
              />
            </IonCol>
          </IonRow>
          {cartPictures.length > 0 && (
            <IonRow>
              <IonCol className="center" style={{ justifyContent: "center" }}>
                <IonButton
                  color="success"
                  disabled={disabledButton}
                  onClick={framesAssembledAsPicturesToggle}
                >
                  <IonIcon
                    icon={framesAssembledAsPictures ? checkbox : squareOutline}
                    color="light"
                    size="large"
                    slot="start"
                  />
                  Sklopljen ram za svaku sliku
                </IonButton>
              </IonCol>
            </IonRow>
          )}
        </IonGrid>
      )}
      {disabled && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>Trenutno nema na stanju</IonLabel>
        </div>
      )}
      {disabledButton && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>
            Trenutno nismo u mogućnosti da šaljemo za Bosnu i Hercegovinu.
          </IonLabel>
        </div>
      )}
    </IonCard>
  );
};

export default FrameAssembled;
